/* eslint-disable max-len */
const life = {
  title: "Treat yourself to a new career",
  about: {
    title: "Who are we?",
    body: `<p>We’re the world’s leading marketplace for booking hair and beauty. Our mission is to create the perfect hair and beauty experience by seamlessly connecting customers with the right expert 24 hours a day, 7 days a week. We want to make people GLOW one treatment at a time.</p>
    <p>We’ve got big goals and big ambitions. Being a global leader means aiming high and executing better than anyone else. To do this we need more brilliantly-talented Treatwellers who share our global mission to shift an industry online.</p>`
  },
  weAre: [
    {
      title: "We are Ambitious",
      body: "Our team truly believes in our mission to disrupt a global industry. We work passionately and tirelessly to make this happen; playing to each other's strengths, ensuring ideas are heard, and bringing the best out of all of us.",
      image: "/img/jobs/we_are/we-are-ambitious.jpg"
    },
    {
      title: "We are One",
      body: "Our team operates in 11 countries across Europe. That makes us a family of 500 amazing Treatwellers, made up of more than 30 nationalities and countless personalities. Diversity is our strength.",
      image: "/img/jobs/we_are/we-are-one.jpg"
    },
    {
      title: "We are Treatworthy",
      body: "Our ethos is 'work hard, treat well'. We offer flexible holidays, wellness funding, fully stocked kitchens, regular social events and lots of magical moments - that’s what makes us glow.",
      image: "/img/jobs/we_are/we-are-treatworthy.jpg"
    }
  ],
  values: {
    title: "Our values",
    body: ""
  },
  be: [
    {
      title: "We can only succeed with each other",
      body: "<p>For our company to be successful, we need more than just bookings. We need a team of motivated, driven employees who push each other’s boundaries and go the extra mile. That healthy kind of pressure creates a strong group of leaders – for our partners, for our customers, and for the industry.</p>",
      image: "/img/jobs/value_succeed_eachother.svg"
    },
    {
      title: "We take responsibility and act like owners",
      body: "<p>While job titles might steer our to-do lists, they don’t define our role as individuals. We take ownership beyond the day job, committing to the company’s wider goals (not just personal KPIs). We act like company shareholders – aware of how we spend time and money – and give everything our all, efficiently. Industry leaders don’t waste time, after all.</p>",
      image: "/img/jobs/value_responsibility.svg"
    },
    {
      title: "We go beyond good enough",
      body: "<p>Good enough isn’t good enough. That’s why we continue to be courageous, question the status quo, welcome new ideas and challenge what’s come before. We believe in innovation and creating an impact, asking ourselves daily ‘can we do this better?’. \n" +
        "So long as the answer is yes, we’ll always have more work to do.</p>",
      image: "/img/jobs/value_beyond_good.svg"
    },
  ],
  lifeAt: {
    title: "Life at Treatwell",
    body: "We believe that life at Treatwell is more than just a job. You’ll broaden your horizons and develop both personally and professionally. It's important to us that your teammates and environment energise and inspire you. If you join the team, you’ll be treated with events, parties, workshops, challenges, team sports, and too much more to mention!",
    images: [{
      src: "life_at_0000.jpg",
      title: ""
    }, {
      src: "life_at_0009.jpg",
      title: ""
    }, {
      src: "life_at_0002.jpg",
      title: ""
    }, {
      src: "life_at_0003.jpg",
      title: ""
    }, {
      src: "life_at_0007.jpg",
      title: ""
    }, {
      src: "life_at_0006b.jpg",
      title: "Colin Michel @ Technoball Vienna"
    }, {
      src: "life_at_0004.jpg",
      title: ""
    }, {
      src: "life_at_0001.jpg",
      title: ""
    }, {
      src: "life_at_0012.jpg",
      title: ""
    }, {
      src: "life_at_0005.jpg",
      title: ""
    }, {
      src: "life_at_0010.jpg",
      title: ""
    }, {
      src: "life_at_0013.jpg",
      title: ""
    }, {
      src: "life_at_0008.jpg",
      title: ""
    }, {
      src: "life_at_0014.jpg",
      title: ""
    }, {
      src: "life_at_0011.jpg",
      title: ""
    }
    ]
  }
};

const tech = {
  title: "Technology at Treatwell",
  about: {
    body: `<p>Here in the Treatwell tech team we're a nice bunch, who love to ship software and we like to think we're pretty smart. We like to use the right tech for the job but we don't get seduced by the latest shiny fads.</p>
    <p>The products we build and maintain include the consumer facing Treatwell marketplace and Connect, the software our partner salons use to run their businesses. Both are available on the web and as native apps for iOS and Android, and all in eleven countries across Europe.</p>`
  },
  culture: {
    title: "Culture",
    image: "/img/jobs/offices/tech-culture.jpg",
    body: `<p>It takes more than a ping pong table and a beer fridge to make an exceptional engineering culture. Leadership is a team effort and we are all empowered to make meaningful decisions about what we do and how we work, and we do everything at a sustainable pace. We trust each other and we support each other. We speak our minds and everyone's opinions are respected.</p>
  <p>Treatwell is building a Hair and Beauty marketplace but, really, we’re a Technology business. The tech team is respected and trusted to do great work, and we understand that our job is to deliver an amazing experience for our users.</p>
  <p>Complacency is our enemy. We strive to get better as individuals and as a team and we are never done learning. We go home happy when we have done work of which we can be very proud.</p>
  <p>Our tech teams are based in London and Vilnius and, whichever one is your home, you'll get the opportunity to visit the other if you want to. Both are fun cities and maybe you can help us settle the argument over which has the best coffee and burgers.</p>`
  },
  stack: {
    title: "Stack",
    body: "Agile principles and values are important to us, our cross-functional teams use Kanban or Scrum and various XP practices. We believe in ATDD, automated testing and continuous integration and we want to do them all brilliantly.",
    body2: "On our journey towards continuous delivery, we’re evolving our architecture, using DDD to build loosely coupled, independently deployable applications.",
    body3: "Our tech stack is chosen for scale. We're building a huge business and a platform to match.",
    join: {
      body: "We’re building something very special here in Tech at Treatwell and we’re looking for brilliant people who can help us on that journey."
    },
    logos: [
      {
        title: "Java",
        image: "/img/jobs/tech/careers-tech-java-8@2x.png"
      },
      {
        title: "AWS",
        image: "/img/jobs/tech/careers-tech-aws@2x.png"
      },
      {
        title: "Spring Boot",
        image: "/img/jobs/tech/careers-tech-logo-spring-boot.png"
      },
      {
        title: "Docker",
        image: "/img/jobs/tech/careers-tech-docker@2x.png"
      },
      {
        title: "Postgres",
        image: "/img/jobs/tech/careers-tech-postgresql@2x.png"
      },
      {
        title: "Redis",
        image: "/img/jobs/tech/careers-tech-redis@2x.png"
      },
      {
        title: "RabbitMQ",
        image: "/img/jobs/tech/careers-tech-rabbitmq@2x.png"
      },
      {
        title: "Typescript",
        image: "/img/jobs/tech/careers-tech-logo-typescript.png"
      },
      {
        title: "NodeJS",
        image: "/img/jobs/tech/careers-tech-logo-node@2x.png"
      },
      {
        title: "ReactJS",
        image: "/img/jobs/tech/careers-tech-logo-react@2x.png"
      },
      {
        title: "Swift",
        image: "/img/jobs/tech/careers-tech-logo-swift@2x.png"
      },
      {
        title: "Kotlin",
        image: "/img/jobs/tech/careers-tech-logo-kotlin@2x.png"
      },
      {
        title: "Pact",
        image: "/img/jobs/tech/careers-tech-logo-pact.png"
      },
      {
        title: "Gitlab",
        image: "/img/jobs/tech/careers-tech-logo-gitlab.png"
      },
      {
        title: "Jenkins",
        image: "/img/jobs/tech/careers-tech-logo-jenkins@2x.png"
      }
    ]
  }

};

const pages = {
  life,
  tech
};

const offices = [
  {
    name: "UK & Ireland",
    title: "Welcome to Treatwell UK & Ireland",
    body: "<p>Here at our Treatwell HQ in Holborn, London, we’re more than 140 employees. And we have another 30 working remotely throughout the UK and Ireland.</p><p>Our London office has a design feel with wooden floors, exposed brickwork, bright colours, and Sonos when the mood takes us. We treat ourselves to a fully-stocked kitchen with Nespresso coffee, fresh fruit, and an impressive breakfast selection. We don’t feel the need for a ping pong table or Xbox, that’s not really our style. We prefer getting social, and we do a lot of it, with Friday drinks a popular event in our weekly calendar.</p>",
    image: "/img/jobs/offices/office-uk.jpg",
    linkLabel: "View positions in UK and Ireland",
    workableCountryCodes: ["GB", "IE"]
  },
  {
    name: "BENELUX",
    title: "Welcome to Treatwell Benelux",
    body: "<p>We’re based in the heart of Amsterdam with amazing panoramic views over the city skyline. We have a catered lunch room where 70 of our Amsterdam-based Treatwellers enjoy getting together. We love our social events - like heading to our local canal-side bar most Fridays, and when our partners come to offer us free treatments in our office.</p><p>Our Belgium sales team works remotely and joins us in Amsterdam whenever they can. By day they are building the business partnerships across our main key cities of Antwerp, Brussels, Ghent and Leuven.</p>",
    image: "/img/jobs/offices/office-bnl.jpg",
    linkLabel: "View positions in the Benelux",
    workableCountryCodes: ["BE", "NL", "LU"]
  },
  {
    name: "DACH",
    title: "Welcome to Treatwell DACH",
    body: "<p>We’re a big team of over 80 Treatwellers across Germany, Switzerland and Austria. Our main DACH office is in central Berlin in an uber-cool converted warehouse. The office has a distinct design feel; open plan, light and lots of plants to clean the air!</p><p>We get together often. We like to celebrate our wins and treat our team well by making sure that everyone has fresh fruit and great coffee as key essentials!</p>",
    image: "/img/jobs/offices/office-dach.jpg",
    linkLabel: "View positions in DACH",
    workableCountryCodes: ["DE", "CH", "AT"]
  },
  {
    name: "France",
    title: "Welcome to Treatwell France",
    body: "<p>Located just a few steps from the Galeries Lafayette, our lovely Parisian office is a haven of inspiration.</p><p>You’ll enter into the main open-plan office space, home to our amazing sales team. Step further in and you’ll discover the marketing office, buzzing with a creative vibe.</p><p>Need to chill? Head to our jungle-themed rest room, with a sofa to relax on and some cute tables to share a lunch together.</p><p>We are a small but impactful team of 25, with a large Operations Team supporting us from Barcelona.</p>",
    image: "/img/jobs/offices/office-fr.jpg",
    linkLabel: "View positions in France",
    workableCountryCodes: ["FR"]
  },
  {
    name: "Italy",
    title: "Welcome to Treatwell Italy",
    body: "<p>Come to Milan and be a member of a growing team with a lot of energy and passion!</p><p>Our elegant offices are located in a traditional building in the heart of the city, just off Corso Buenos Aires. We're surrounded by wonderful restaurants and beautiful streets where we love to relax after a day's work.</p><p>Here at Treatwell Milan we like to spend time with the team in our communal areas, enjoying events, parties and celebrations.</p>",
    image: "/img/jobs/offices/office-it.jpg",
    linkLabel: "View positions in Italy",
    workableCountryCodes: ["IT"]
  },
  {
    name: "Lithuania",
    title: "Welcome to Treatwell Lithuania",
    body: "<p>Treatwell Lithuania is a strong, diverse (and ever-growing) team that is largely focused on technology. The team here in Vilnius is very proud to own the product strategy and the technology for Connect, the software our partner salons use to run their businesses.</p><p>Alongside our cross-skilled tech team, we also have a supply team who work very hard to maintain and develop the well-performing market in Lithuania.</p><p>Our office is an open plan Scandi-style space-based near the old town and the centre of Vilnius. We've come a long way as one of the first acquisitions to the Treatwell group and Lithuanian character is very much a part of our DNA.</p>",
    image: "/img/jobs/offices/office-lt.jpg",
    linkLabel: "View positions in Lithuania",
    workableCountryCodes: ["LT"]
  },
  {
    name: "Spain",
    title: "Welcome to Treatwell Spain",
    body: "<p>Treatwell Spain is in the heart of Barcelona, just off the buzzing Plaza Catalunya. You'll find us in our open-plan office space enjoying spectacular views of the city, in a building surrounded by shops, restaurants and bars. And the beach is close too!</p><p>Our Operations Team forms a large part of the office and brings a truly international atmosphere. There are more than 70 of us, with multiple nationalities, servicing customers and partners across the Treatwell globe.</p><p>We love spending time with each other and regularly gather for parties, events, language classes, and celebrations. Join us!</p>",
    image: "/img/jobs/offices/office-es.jpg",
    linkLabel: "View positions in Spain",
    workableCountryCodes: ["ES"]
  }
];

const teams = [
  {
    id: 0,
    name: "Supply",
    workableDepartmentCodes: ["Management", "Sales", "City Manager", "Partner Growth", "Partner Acquisition", "Account Management"],
    color: "#00b0b9",
    image: "/img/jobs/careers-department-sales-management.svg",
    body: "Bringing new partners on board, helping them digitalise their businesses  and ensuring that they get the most out of our relationship is a critical and rewarding part of our business. Our Sales Teams comprise telesales and field sales working hand in hand to educate and shift an industry online. Once onboard the partners are carefully handed over to the Account Management Team who maintain, nurture and grow these partnerships, and in turn help grow the salon businesses themselves. Relationship building and the ability to understand and respond to the customer needs and aspirations are vital.",
    members: [
      {
        name: "Daan",
        role: "Sales Specialist",
        quote: "I started in the Inside Sales team before moving into new markets, which is going to a new city in the UK every three months and helping Treatwell build up the salon base in those locations. What I love about Treatwell is constantly being given the opportunity to personally and professionally develop myself. That, with the combination of a very friendly workforce and the autonomy to get the work done, makes Treatwell an amazing place to work.",
        image: "/img/jobs/team/daan-sales.jpg"
      },
      {
        name: "Estee",
        role: "Senior Account Manager",
        quote: "As an account manager we strive to build long term and successful relationships with (key)accounts and make sure that our partner salons understand the advantages of our Treatwell platform, our salon software and tools. We ensure they are motivated to completely adapt to our software. It is a commercial role and we have a lot of contact with the salon owners, listen to their goals and give them data insights to improve their business and help them grow. As a senior I am constantly looking to improve intern processes which are efficient and beneficial for the team. Treatwell has a great atmosphere with lots of freedom & responsibility. There is room to grow and you can easily start your own projects when this is matching with the KPIs of the company.",
        image: "/img/jobs/team/estee-sales.jpg"
      },
      {
        name: "Zac",
        role: "Supply Insights Analyst",
        quote: "Treatwell is an amazing place to work! We’re always looking to raise the bar and drive the business forwards; leveraging our plethora of data plays an instrumental part in this.I love having the freedom and responsibility to solve interesting problems end-to-end, provide data-driven recommendations and see my proposals implemented with impetus. Things change quickly here, as we evolve and iterate our way to success. This makes for a beautifully varied workload, along with opportunities to learn and attain acumen every day.When you join Treatwell, you’re not only joining a new company, you're becoming part of a family of smart, ambitious and tenaciously supportive people, with a real passion for getting things done.",
        image: "/img/jobs/team/zac-accounts.jpg"
      }
    ]
  },
  {
    id: 1,
    name: "Marketing",
    workableDepartmentCodes: ["Brand and Creative", "Organic Growth", "Performance Marketing", "Regional Growth", "Partner Marketing"],
    color: "#efdf00",
    image: "/img/jobs/careers-department-marketing.svg",
    body: "Using our brand’s creativity and integrated channels, our Marketing Team  drives a constant stream of happy and satisfied customers and partners to Treatwell, in the most efficient way possible. Dedicated to our vision of making people glow by delivering the perfect hair and beauty experience, this team is our eyes, ears and voice, engaging and inspiring beauty customers across Europe. Our team is made up of Performance Marketing, Brand, Design, Editorial and Content, Local Marketing and CRM and make up the biggest function at Treatwell. To be a successful member of this team you will be driven by creativity, have an eye for impactful design and a (quite possibly unhealthy) love of data!",
    members: [
      {
        name: "Elsa",
        role: "Marketing Technology Lead UK",
        quote: "I love working in the Marketing Team at Treatwell, solving real challenges the business is facing every day and you can see the impact of your actions. Working closely with really talented and driven people to build an efficient acquisition and retention machine, to make it easy for people to find and book their hair and beauty appointments as seamlessly as possible. I haven't stopped learning since joining in 2018 and the areas for development are limitless. Treatwell also has a great social atmosphere.",
        image: "/img/jobs/team/elsa-brand.jpg"
      },
      {
        name: "Alba Duran",
        role: "Social Media Manager & Campaign Producer",
        quote: "I want to make people fall in love with our brand and become their referent for all things beauty related. From the coolest nail-art to the latest hairdo, or the most relaxing treatments, we want users to know that Treatwell is the brighter way to book beauty. The office environment and my colleagues are the main reason why I love what I do.",
        image: "/img/jobs/team/alba-marketing.jpg"
      },
      {
        name: "Lorenzo",
        role: "Director of Performance Marketing and Analytics",
        quote: "Leading the Performance Marketing and Analytics team I am responsible for Treatwell digital marketing strategy, with the objective of growing our customer base by investing in the right channel, with the right message, to the right audience. It requires the right combination of technological innovation, marketing intuition and analytical capabilities to deliver a strong performance in an ever changing complex market. That’s the key of our success, and the reason why Treatwell is an intellectually stimulating place to work.",
        image: "/img/jobs/team/lorenzo-marketing.jpg"
      }
    ]
  },
  {
    id: 2,
    name: "Technology",
    workableDepartmentCodes: ["Technology"],
    color: "#d6cf8d",
    image: "/img/jobs/careers-department-technology.svg",
    body: "Whilst Treatwell is a Hair and Beauty business, technology is front and centre. The products we build and maintain include the consumer-facing Treatwell marketplace and Connect, the software our partner salons use to run their businesses. Both are available on the web and as native apps for iOS and Android, in eleven countries across Europe. Based in London and Vilnius, we’re a nice bunch, who love to ship valuable software. Agile principles and values are important to us, and our Engineers, Product Managers and Product Designers work together in independent, cross-functional teams. We like to use the right tech for the job and we aren’t seduced by the latest shiny fads. We’re building a huge business and a technology platform to match.",
    members: [
      {
        name: "Laura",
        role: "Lead Product Manager",
        quote: "Most of my time is spent working collaboratively across the product, tech, and design teams as we work to create great digital products for our customers. I love the variety of my day to day, which varies from user testing to design review to sprint plannings. The best thing here is that there's real trust put into the team and individuals, which makes for a fantastic creative environment",
        image: "/img/jobs/team/laura-tech.png"
      },
      {
        name: "Dalia",
        role: "Software Engineer",
        quote: "Treatwell is a great place to learn and grow as a backend engineer. Being surrounded by so many talented people encourages me to push myself and raise the bar in the work I do everyday. The best thing about being part of the tech team is being genuinely trusted by the people I work with and the freedom to make choices on how I want to work and grow - which is important to me as a developer.",
        image: "/img/jobs/team/dalia-tech.jpg"
      },
      {
        name: "Dominic",
        role: "Systems Architect",
        quote: "My days at Treatwell are very varied. Anything from dealing with production issues (not that we have any of those) to planning for the long-term scalability of the system. I can honestly say that in 17 years in the tech industry, I have never worked with such a talented and dedicated group of people",
        image: "/img/jobs/team/bev-tech.png"
      }
    ]
  },
  {
    id: 3,
    name: "Group Functions",
    workableDepartmentCodes: ["Strategic Partnerships", "Admin", "Talent Management", "Finance", "Legal", "Photography", "Strategic Development"],
    color: "#78d64b",
    image: "/img/jobs/careers-department-global.svg",
    body: "Most of the Group Function roles are centralised at our HQ in Holborn, London. These teams comprise Finance, HR, Legal, Office Management, and Fraud and Compliance. They are the serum that holds the other functions together. The enablers of business efficiency and growth. Subject-matter expertise is critical for these teams but equally important is the ability to understand and support multiple cultures, functions, currencies, legislation and personalities, which makes working in these teams incredibly colourful and rewarding.",
    members: [
      {
        name: "Moo",
        role: "UK Office Manager & People Operations Support",
        quote: "As overseer of all things office-related it's my job to keep the office and everything in it running smoothly, I also work within the People Team to help maintain our culture and bring Treatwellers together through topical events and engaging activities, assisting with people operations to support and engage treatwellers old and new. Day-to-day I'm focused on creating and maintaining a functional and enjoyable work environment where everyone at Treatwell can look forward to coming to the office .No two days are the same and it's important to have a sense of humour.",
        image: "/img/jobs/team/moo-hr.jpg"
      },
      {
        name: "Arianne",
        role: "Accounts Assistant",
        quote: "In 2018 I joined Treatwell as an apprentice and I have not looked back! I've had such great exposure of the different functions of a finance department. I started in accounts payable and finance operations then I moved over to the management accounting team.  My development at has never stopped from the day I started and I am currently sitting exams towards my AAT qualification. I've been really lucky with this opportunity as the team have always been fully supportive of my studies, which results in a rather busy yet balanced study/work/life balance!",
        image: "/img/jobs/team/arianne-support.jpg"
      },
      {
        name: "Ian",
        role: "FinOps Manager - UK",
        quote: "Since joining Treatwell in 2009 as a customer service operative, I’ve been fortunate to see so many changes in the company from office relocations, developments in the organisation’s structure, increase in colleague numbers and the creation of a great working environment and culture. Now my Treatwell journey continues as I get the opportunity to grow in my support role of Finance Operations Manager.",
        image: "/img/jobs/team/ian-support.jpg"
      }
    ]
  },
  {
    id: 4,
    name: "Customer Operations & Content",
    workableDepartmentCodes: ["Customer Experience Operations", "Marketplace Content"],
    color: "#ff808b",
    image: "/img/jobs/careers-department-operations.svg",
    body: "A lot happens behind the scenes to guide the perfect connection between a partner and their client, every time. In Barcelona the Marketplace Content team ensure that partners have the best looking profiles in town, and that consumers can easily find the exact service they are looking for, or maybe even inspire trying something completely new. Meanwhile, the Customer Experience teams (based in Amsterdam, Barcelona and Berlin) provide daily frontline support to both consumers and partners. Across the three locations are nearly 100 passionate, multi-lingual people ready to serve our customers and partners in their time of need. We look for people who love to solve problems, are keen to use their initiative to innovate and get a kick out of providing the best possible customer experience, every day.",
    members: [
      {
        name: "Hervé",
        role: "Marketplace Content Group Director",
        quote: "We are here to make sure that at any single step of the customer's journey, people feel happy. But is not only about our customers, it is also about our team. I have to do my best to offer our employees the best environment possible. Every single day, I love to see happy people sharing our values, openness, courage and drivenness, making our users Glow. Treatwell is the future of hair and beauty and being part of it is a real opportunity.",
        image: "/img/jobs/team/herve-director.jpg"
      },
      {
        name: "Arielle",
        role: "CX Specialist",
        quote: "I've been in Customer Experience since 2018, I am enthusiastic about supporting and helping our users - partners & customers - on a daily basis so that my team and I can offer the best possible experience. As my background is in beauty and I am passionate about the world of beauty, which makes Life at Treatwell ideal for me. It's a pleasure to share my days with my team in a friendly and relaxed atmosphere. So, when are you joining us?",
        image: "/img/jobs/team/arielle-support.jpg"
      },
      {
        name: "German",
        role: "Marketplace Content Specialist",
        quote: "Content is the outcome of the partners’ wishes. My job is to highlight the know-how of each of our partners with studied and analyzed content that perfectly reflects the identity of the salons and institutes. In my opinion, this role is important. Why? Because it represents the identity of Treatwell and the fabulous work our partners do. I love this position that allows me to have direct links with other departments, and learn everyday!",
        image: "/img/jobs/team/german-operations.jpg"
      }
    ]
  },
  {
    id: 5,
    name: "Talent Pool",
    workableDepartmentCodes: ["Talent Pool"],
    color: "#001e62",
    image: "/img/jobs/careers-department-talent-pool.svg",
    body: "We always want to hear from candidates who are passionate about our brand and product, which is why we created our Talent Community. If you can’t see an open position that matches what you’re looking for, but want to stay one step ahead, send us your CV through this application.",
    members: []
  }
];

const footer = {
  columns: [
    {
      title: "Company",
      links: [
        {
          label: "Legal",
          href: "https://www.treatwell.co.uk/inspiration/legal/"
        },
        {
          label: "Privacy Policies",
          href: "https://www.treatwell.co.uk/inspiration/terms-and-policies/"
        },
        {
          label: "About Us",
          href: "https://www.treatwell.co.uk/inspiration/about-us/"
        },
        {
          label: "Contact Us / Impressum",
          href: "https://www.treatwell.co.uk/inspiration/contact-page/"
        }
      ]
    }
  ]
};

const Content = {
  pages,
  offices,
  teams,
  footer
};

export default Content;



// WEBPACK FOOTER //
// ./lib/Static.js